import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _f82e6c3c = () => interopDefault(import('../pages/tt.html.vue' /* webpackChunkName: "pages/tt.html" */))
const _71f72c1c = () => interopDefault(import('../pages/HealthCheck/Get.vue' /* webpackChunkName: "pages/HealthCheck/Get" */))
const _630865ce = () => interopDefault(import('../pages/help/instructions-for-using-vps.html.vue' /* webpackChunkName: "pages/help/instructions-for-using-vps.html" */))
const _1479741b = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _60df5e99 = () => interopDefault(import('../pages/_lang/index.vue' /* webpackChunkName: "pages/_lang/index" */))
const _50430c16 = () => interopDefault(import('../pages/_lang/connector.html.vue' /* webpackChunkName: "pages/_lang/connector.html" */))
const _18f38168 = () => interopDefault(import('../pages/_lang/detection.vue' /* webpackChunkName: "pages/_lang/detection" */))
const _166f32e4 = () => interopDefault(import('../pages/_lang/eashop.html.vue' /* webpackChunkName: "pages/_lang/eashop.html" */))
const _66d9655f = () => interopDefault(import('../pages/_lang/Help.html.vue' /* webpackChunkName: "pages/_lang/Help.html" */))
const _4287da74 = () => interopDefault(import('../pages/_lang/jyzh.vue' /* webpackChunkName: "pages/_lang/jyzh" */))
const _637f3ed9 = () => interopDefault(import('../pages/_lang/login.html.vue' /* webpackChunkName: "pages/_lang/login.html" */))
const _350794b0 = () => interopDefault(import('../pages/_lang/return.html.vue' /* webpackChunkName: "pages/_lang/return.html" */))
const _1619bf89 = () => interopDefault(import('../pages/_lang/vps.html.vue' /* webpackChunkName: "pages/_lang/vps.html" */))
const _62fad6c6 = () => interopDefault(import('../pages/_lang/zhsy.vue' /* webpackChunkName: "pages/_lang/zhsy" */))
const _62d54f76 = () => interopDefault(import('../pages/_lang/zhsyDownload.vue' /* webpackChunkName: "pages/_lang/zhsyDownload" */))
const _fb7364b8 = () => interopDefault(import('../pages/_lang/app/app-help.vue' /* webpackChunkName: "pages/_lang/app/app-help" */))
const _a69cd346 = () => interopDefault(import('../pages/_lang/app/app-help-buy.vue' /* webpackChunkName: "pages/_lang/app/app-help-buy" */))
const _60cbe23d = () => interopDefault(import('../pages/_lang/app/app-help-classify.vue' /* webpackChunkName: "pages/_lang/app/app-help-classify" */))
const _81156920 = () => interopDefault(import('../pages/_lang/app/app-help-issue.vue' /* webpackChunkName: "pages/_lang/app/app-help-issue" */))
const _61819eb4 = () => interopDefault(import('../pages/_lang/app/app-help-mac.vue' /* webpackChunkName: "pages/_lang/app/app-help-mac" */))
const _25d61878 = () => interopDefault(import('../pages/_lang/app/app-help-mt4.vue' /* webpackChunkName: "pages/_lang/app/app-help-mt4" */))
const _25b9e976 = () => interopDefault(import('../pages/_lang/app/app-help-mt5.vue' /* webpackChunkName: "pages/_lang/app/app-help-mt5" */))
const _4c960287 = () => interopDefault(import('../pages/_lang/app/app-help-trader.vue' /* webpackChunkName: "pages/_lang/app/app-help-trader" */))
const _d5771644 = () => interopDefault(import('../pages/_lang/app/app-help-use.vue' /* webpackChunkName: "pages/_lang/app/app-help-use" */))
const _23016e9a = () => interopDefault(import('../pages/_lang/app/app-help-win.vue' /* webpackChunkName: "pages/_lang/app/app-help-win" */))
const _d8839268 = () => interopDefault(import('../pages/_lang/app/app-introduce.vue' /* webpackChunkName: "pages/_lang/app/app-introduce" */))
const _24af4531 = () => interopDefault(import('../pages/_lang/app/new-app-help.vue' /* webpackChunkName: "pages/_lang/app/new-app-help" */))
const _12a2fc4a = () => interopDefault(import('../pages/_lang/data/BurstData.html.vue' /* webpackChunkName: "pages/_lang/data/BurstData.html" */))
const _b1b8620a = () => interopDefault(import('../pages/_lang/data/Burstdetails.html.vue' /* webpackChunkName: "pages/_lang/data/Burstdetails.html" */))
const _8d887388 = () => interopDefault(import('../pages/_lang/data/cashflow.html.vue' /* webpackChunkName: "pages/_lang/data/cashflow.html" */))
const _1042d5ba = () => interopDefault(import('../pages/_lang/data/deeptracking.html.vue' /* webpackChunkName: "pages/_lang/data/deeptracking.html" */))
const _86cafeea = () => interopDefault(import('../pages/_lang/data/earanking.html.vue' /* webpackChunkName: "pages/_lang/data/earanking.html" */))
const _6055c056 = () => interopDefault(import('../pages/_lang/data/EnvContrast.html.vue' /* webpackChunkName: "pages/_lang/data/EnvContrast.html" */))
const _a6b6bcb2 = () => interopDefault(import('../pages/_lang/data/EnvDetail.html.vue' /* webpackChunkName: "pages/_lang/data/EnvDetail.html" */))
const _6bc55c74 = () => interopDefault(import('../pages/_lang/data/EnvRanking.html.vue' /* webpackChunkName: "pages/_lang/data/EnvRanking.html" */))
const _12904415 = () => interopDefault(import('../pages/_lang/data/holdposition.html.vue' /* webpackChunkName: "pages/_lang/data/holdposition.html" */))
const _f34ebd6a = () => interopDefault(import('../pages/_lang/data/holdpositiondetails.html.vue' /* webpackChunkName: "pages/_lang/data/holdpositiondetails.html" */))
const _673468f4 = () => interopDefault(import('../pages/_lang/data/position.html.vue' /* webpackChunkName: "pages/_lang/data/position.html" */))
const _f155cae6 = () => interopDefault(import('../pages/_lang/data/tradingquotes.html.vue' /* webpackChunkName: "pages/_lang/data/tradingquotes.html" */))
const _cf7f27c6 = () => interopDefault(import('../pages/_lang/eashop/download.html.vue' /* webpackChunkName: "pages/_lang/eashop/download.html" */))
const _06a4f298 = () => interopDefault(import('../pages/_lang/help/buy-vps-server-process.html.vue' /* webpackChunkName: "pages/_lang/help/buy-vps-server-process.html" */))
const _3ea59fa3 = () => interopDefault(import('../pages/_lang/help/ctrader-account-binding-process.html.vue' /* webpackChunkName: "pages/_lang/help/ctrader-account-binding-process.html" */))
const _c5442bf8 = () => interopDefault(import('../pages/_lang/help/help-list.html.vue' /* webpackChunkName: "pages/_lang/help/help-list.html" */))
const _0d08f01e = () => interopDefault(import('../pages/_lang/help/helpCourseVps.html.vue' /* webpackChunkName: "pages/_lang/help/helpCourseVps.html" */))
const _37e64177 = () => interopDefault(import('../pages/_lang/help/helpEa.html.vue' /* webpackChunkName: "pages/_lang/help/helpEa.html" */))
const _6f59dbb3 = () => interopDefault(import('../pages/_lang/help/helpIssueVps.html.vue' /* webpackChunkName: "pages/_lang/help/helpIssueVps.html" */))
const _d24491c0 = () => interopDefault(import('../pages/_lang/help/helpMac.html.vue' /* webpackChunkName: "pages/_lang/help/helpMac.html" */))
const _0a1b9f33 = () => interopDefault(import('../pages/_lang/help/helpWin.html.vue' /* webpackChunkName: "pages/_lang/help/helpWin.html" */))
const _27b6a8e0 = () => interopDefault(import('../pages/_lang/help/instructions-for-using-vps.html.vue' /* webpackChunkName: "pages/_lang/help/instructions-for-using-vps.html" */))
const _edc4411e = () => interopDefault(import('../pages/_lang/help/mobileHelp.html.vue' /* webpackChunkName: "pages/_lang/help/mobileHelp.html" */))
const _dfb6a832 = () => interopDefault(import('../pages/_lang/help/mt4-account-binding-process.html.vue' /* webpackChunkName: "pages/_lang/help/mt4-account-binding-process.html" */))
const _65771ff4 = () => interopDefault(import('../pages/_lang/help/mt5-account-binding-process.html.vue' /* webpackChunkName: "pages/_lang/help/mt5-account-binding-process.html" */))
const _e4f29788 = () => interopDefault(import('../pages/_lang/help/vps-product-classification.html.vue' /* webpackChunkName: "pages/_lang/help/vps-product-classification.html" */))
const _4fa87ece = () => interopDefault(import('../pages/_lang/data/broker/_broker.vue' /* webpackChunkName: "pages/_lang/data/broker/_broker" */))
const _500c29c4 = () => interopDefault(import('../pages/_lang/data/burst/_details.vue' /* webpackChunkName: "pages/_lang/data/burst/_details" */))
const _417d8864 = () => interopDefault(import('../pages/_lang/data/earanking/_details.vue' /* webpackChunkName: "pages/_lang/data/earanking/_details" */))
const _75b9f83b = () => interopDefault(import('../pages/_lang/eashop/getdetails/_id.vue' /* webpackChunkName: "pages/_lang/eashop/getdetails/_id" */))
const _147f358f = () => interopDefault(import('../pages/_lang/data/_details.vue' /* webpackChunkName: "pages/_lang/data/_details" */))
const _bd50f5f4 = () => interopDefault(import('../pages/_lang/eashop/_id.vue' /* webpackChunkName: "pages/_lang/eashop/_id" */))
const _50e793f5 = () => interopDefault(import('../pages/_lang/help/_id.vue' /* webpackChunkName: "pages/_lang/help/_id" */))
const _eedc5826 = () => interopDefault(import('../pages/_lang/vpsconfig/_id.vue' /* webpackChunkName: "pages/_lang/vpsconfig/_id" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/tt.html",
    component: _f82e6c3c,
    name: "tt.html"
  }, {
    path: "/HealthCheck/Get",
    component: _71f72c1c,
    name: "HealthCheck-Get"
  }, {
    path: "/help/instructions-for-using-vps.html",
    component: _630865ce,
    name: "help-instructions-for-using-vps.html"
  }, {
    path: "/",
    component: _1479741b,
    name: "index"
  }, {
    path: "/:lang",
    component: _60df5e99,
    name: "lang"
  }, {
    path: "/:lang/connector.html",
    component: _50430c16,
    name: "lang-connector.html"
  }, {
    path: "/:lang/detection",
    component: _18f38168,
    name: "lang-detection"
  }, {
    path: "/:lang/eashop.html",
    component: _166f32e4,
    name: "lang-eashop.html"
  }, {
    path: "/:lang/Help.html",
    component: _66d9655f,
    name: "lang-Help.html"
  }, {
    path: "/:lang/jyzh",
    component: _4287da74,
    name: "lang-jyzh"
  }, {
    path: "/:lang/login.html",
    component: _637f3ed9,
    name: "lang-login.html"
  }, {
    path: "/:lang/return.html",
    component: _350794b0,
    name: "lang-return.html"
  }, {
    path: "/:lang/vps.html",
    component: _1619bf89,
    name: "lang-vps.html"
  }, {
    path: "/:lang/zhsy",
    component: _62fad6c6,
    name: "lang-zhsy"
  }, {
    path: "/:lang/zhsyDownload",
    component: _62d54f76,
    name: "lang-zhsyDownload"
  }, {
    path: "/:lang/app/app-help",
    component: _fb7364b8,
    name: "lang-app-app-help"
  }, {
    path: "/:lang/app/app-help-buy",
    component: _a69cd346,
    name: "lang-app-app-help-buy"
  }, {
    path: "/:lang/app/app-help-classify",
    component: _60cbe23d,
    name: "lang-app-app-help-classify"
  }, {
    path: "/:lang/app/app-help-issue",
    component: _81156920,
    name: "lang-app-app-help-issue"
  }, {
    path: "/:lang/app/app-help-mac",
    component: _61819eb4,
    name: "lang-app-app-help-mac"
  }, {
    path: "/:lang/app/app-help-mt4",
    component: _25d61878,
    name: "lang-app-app-help-mt4"
  }, {
    path: "/:lang/app/app-help-mt5",
    component: _25b9e976,
    name: "lang-app-app-help-mt5"
  }, {
    path: "/:lang/app/app-help-trader",
    component: _4c960287,
    name: "lang-app-app-help-trader"
  }, {
    path: "/:lang/app/app-help-use",
    component: _d5771644,
    name: "lang-app-app-help-use"
  }, {
    path: "/:lang/app/app-help-win",
    component: _23016e9a,
    name: "lang-app-app-help-win"
  }, {
    path: "/:lang/app/app-introduce",
    component: _d8839268,
    name: "lang-app-app-introduce"
  }, {
    path: "/:lang/app/new-app-help",
    component: _24af4531,
    name: "lang-app-new-app-help"
  }, {
    path: "/:lang/data/BurstData.html",
    component: _12a2fc4a,
    name: "lang-data-BurstData.html"
  }, {
    path: "/:lang/data/Burstdetails.html",
    component: _b1b8620a,
    name: "lang-data-Burstdetails.html"
  }, {
    path: "/:lang/data/cashflow.html",
    component: _8d887388,
    name: "lang-data-cashflow.html"
  }, {
    path: "/:lang/data/deeptracking.html",
    component: _1042d5ba,
    name: "lang-data-deeptracking.html"
  }, {
    path: "/:lang/data/earanking.html",
    component: _86cafeea,
    name: "lang-data-earanking.html"
  }, {
    path: "/:lang/data/EnvContrast.html",
    component: _6055c056,
    name: "lang-data-EnvContrast.html"
  }, {
    path: "/:lang/data/EnvDetail.html",
    component: _a6b6bcb2,
    name: "lang-data-EnvDetail.html"
  }, {
    path: "/:lang/data/EnvRanking.html",
    component: _6bc55c74,
    name: "lang-data-EnvRanking.html"
  }, {
    path: "/:lang/data/holdposition.html",
    component: _12904415,
    name: "lang-data-holdposition.html"
  }, {
    path: "/:lang/data/holdpositiondetails.html",
    component: _f34ebd6a,
    name: "lang-data-holdpositiondetails.html"
  }, {
    path: "/:lang/data/position.html",
    component: _673468f4,
    name: "lang-data-position.html"
  }, {
    path: "/:lang/data/tradingquotes.html",
    component: _f155cae6,
    name: "lang-data-tradingquotes.html"
  }, {
    path: "/:lang/eashop/download.html",
    component: _cf7f27c6,
    name: "lang-eashop-download.html"
  }, {
    path: "/:lang/help/buy-vps-server-process.html",
    component: _06a4f298,
    name: "lang-help-buy-vps-server-process.html"
  }, {
    path: "/:lang/help/ctrader-account-binding-process.html",
    component: _3ea59fa3,
    name: "lang-help-ctrader-account-binding-process.html"
  }, {
    path: "/:lang/help/help-list.html",
    component: _c5442bf8,
    name: "lang-help-help-list.html"
  }, {
    path: "/:lang/help/helpCourseVps.html",
    component: _0d08f01e,
    name: "lang-help-helpCourseVps.html"
  }, {
    path: "/:lang/help/helpEa.html",
    component: _37e64177,
    name: "lang-help-helpEa.html"
  }, {
    path: "/:lang/help/helpIssueVps.html",
    component: _6f59dbb3,
    name: "lang-help-helpIssueVps.html"
  }, {
    path: "/:lang/help/helpMac.html",
    component: _d24491c0,
    name: "lang-help-helpMac.html"
  }, {
    path: "/:lang/help/helpWin.html",
    component: _0a1b9f33,
    name: "lang-help-helpWin.html"
  }, {
    path: "/:lang/help/instructions-for-using-vps.html",
    component: _27b6a8e0,
    name: "lang-help-instructions-for-using-vps.html"
  }, {
    path: "/:lang/help/mobileHelp.html",
    component: _edc4411e,
    name: "lang-help-mobileHelp.html"
  }, {
    path: "/:lang/help/mt4-account-binding-process.html",
    component: _dfb6a832,
    name: "lang-help-mt4-account-binding-process.html"
  }, {
    path: "/:lang/help/mt5-account-binding-process.html",
    component: _65771ff4,
    name: "lang-help-mt5-account-binding-process.html"
  }, {
    path: "/:lang/help/vps-product-classification.html",
    component: _e4f29788,
    name: "lang-help-vps-product-classification.html"
  }, {
    path: "/:lang/data/broker/:broker?",
    component: _4fa87ece,
    name: "lang-data-broker-broker"
  }, {
    path: "/:lang/data/burst/:details?",
    component: _500c29c4,
    name: "lang-data-burst-details"
  }, {
    path: "/:lang/data/earanking/:details?",
    component: _417d8864,
    name: "lang-data-earanking-details"
  }, {
    path: "/:lang/eashop/getdetails/:id?",
    component: _75b9f83b,
    name: "lang-eashop-getdetails-id"
  }, {
    path: "/:lang/data/:details?",
    component: _147f358f,
    name: "lang-data-details"
  }, {
    path: "/:lang/eashop/:id?",
    component: _bd50f5f4,
    name: "lang-eashop-id"
  }, {
    path: "/:lang/help/:id?",
    component: _50e793f5,
    name: "lang-help-id"
  }, {
    path: "/:lang/vpsconfig/:id?",
    component: _eedc5826,
    name: "lang-vpsconfig-id"
  }, {
    path: "/:lang/sqzj1",
    redirect: "/:lang/vps.html"
  }, {
    path: "/:lang/sqzj2",
    redirect: "/:lang/vps.html"
  }, {
    path: "/:lang/ea.html",
    redirect: "/:lang/vps.html"
  }, {
    path: "/:lang/eashop/index.html",
    redirect: "/:lang/eashop.html"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
